import React from "react";
import { Link } from "react-router-dom";
import {
  Ship,
  PackageCheck,
  Boxes,
  Warehouse,
  ArrowUpRight,
} from "lucide-react";

import ApplicationHeader from "./ApplicationHeader";

const OperationsPortal = () => {
  const services = [
    {
      title: "Cargo Movement",
      text: "Submit cargo movement, import, export and vessel coordination requests.",
      icon: Ship,
    },
    {
      title: "Goods Transfer",
      text: "Request transfers between licensees, facilities and approved Free Zones.",
      icon: Boxes,
    },
    {
      title: "Inventory Update",
      text: "Manage stock records, movement records and operational reconciliation.",
      icon: Warehouse,
    },
  ];

  return (
    <>
      <ApplicationHeader />

      <main className="min-h-screen bg-[#f8fafc]">
        <section className="max-w-7xl mx-auto px-6 py-14">
          <div className="bg-white rounded-[32px] p-8 border border-slate-200 shadow-sm mb-10">
            <div className="w-16 h-16 rounded-2xl bg-[#026b07]/10 text-[#026b07] flex items-center justify-center mb-6">
              <PackageCheck size={32} />
            </div>

            <h2 className="text-4xl font-black text-[#082567] mb-3">
              Operations Portal
            </h2>

            <p className="text-slate-600 max-w-2xl leading-7">
              Coming Soon! This dashboard will support cargo movement, goods
              transfer, operational approvals, inventory updates, document upload
              and request tracking.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {services.map((item, index) => {
              const Icon = item.icon;

              return (
                <div
                  key={index}
                  className="bg-white rounded-[28px] p-7 border border-slate-200 hover:border-[#f2af11] hover:-translate-y-1 transition-all"
                >
                  <div className="w-14 h-14 rounded-2xl bg-[#f2af11]/15 text-[#082567] flex items-center justify-center mb-5">
                    <Icon size={27} />
                  </div>

                  <h3 className="text-xl font-black text-[#082567] mb-3">
                    {item.title}
                  </h3>

                  <p className="text-slate-600 leading-7 text-sm">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-10 text-[#026b07] font-bold hover:text-[#082567]"
          >
            Back to main website
            <ArrowUpRight size={16} />
          </Link>
        </section>
      </main>
    </>
  );
};

export default OperationsPortal;